module.exports = __webpack_public_path__ + "static/media/background2.59c6286a.jpg";